export default "__VITE_ASSET__DzRvzFZs__"